<apx-chart id="chart" #chart
  [series]="chartOptions.series"
  [chart]="chartOptions.chart"
  [xaxis]="chartOptions.xaxis"
  [yaxis]="chartOptions.yaxis"
  [dataLabels]="chartOptions.dataLabels"
  [grid]="chartOptions.grid"
  [stroke]="chartOptions.stroke"
  [tooltip]="chartOptions.tooltip"
  [legend]="chartOptions.legend"
  [colors]="chartOptions.colors"
></apx-chart>

@if (isLoadingData || !stateOfChargeData || ((stateOfChargeData.history?.length ?? 0) === 0 && (stateOfChargeData.prognosis?.length ?? 0) === 0)) {
  <div class="chart-overlay">
    @if (isLoadingData || !stateOfChargeData) {
      <places-spinner></places-spinner>
    } @else {
      <app-feedback-text type="empty">
        <span translate>Could not find any state of charge data for this vehicle</span>
      </app-feedback-text>
    }
  </div>
}


